import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Navigation } from './components/Navigation';
import { Footer } from './components/footer';
import { WhatsAppWidget } from './components/WhatsAppWidget';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Portfolio } from './pages/Portfolio';
import { Contact } from './pages/Contact';
import { RequestQuote } from './pages/RequestQuote';
import { Testimonials } from './pages/Testimonials';
import { ProjectDetails } from './pages/ProjectDetails';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminOverview } from './pages/admin/AdminOverview';
import { ProjectsManagement } from './pages/admin/ProjectsManagement';
import { TestimonialsManagement } from './pages/admin/TestimonialsManagement';
import { ServicesManagement } from './pages/admin/ServicesManagement';
import { ContactManagement } from './pages/admin/ContactManagement';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function ProtectedAdminRoute({ children }) {
  const location = useLocation(); 
  const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
  const isAdmin = localStorage.getItem('isAdmin');

  if (!token || isAdmin !== 'true') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

function AppContent() {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin');

  useEffect(() => {
    const enforceGlobalSecurity = () => {
      if (window.location.pathname.startsWith('/admin')) {
        const validToken = localStorage.getItem('token') || localStorage.getItem('auth_token');
        const validAdmin = localStorage.getItem('isAdmin');
        if (!validToken || validAdmin !== 'true') {
          window.location.replace('/login');
        }
      }
    };
    enforceGlobalSecurity();
    window.addEventListener('popstate', enforceGlobalSecurity);
    
    const handlePageShow = (event) => {
      if (event.persisted) {
        enforceGlobalSecurity(); 
        if (!localStorage.getItem('token')) {
            window.location.reload(); 
        }
      }
    };
    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('popstate', enforceGlobalSecurity);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [location.pathname]); 

  return (
    <LanguageProvider>
      <ScrollToTop />
      {!isAdminPath && <Navigation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:projectId" element={<ProjectDetails />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/request-quote" element={<RequestQuote />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* ADMIN ROUTES */}
        <Route 
          path="/admin" 
          element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }
        >
          <Route index element={<AdminOverview />} />
          <Route path="projects" element={<ProjectsManagement />} />
          <Route path="services" element={<ServicesManagement />} />
          <Route path="testimonials" element={<TestimonialsManagement />} />
          <Route path="contact" element={<ContactManagement />} />
        </Route>
      </Routes>
      {!isAdminPath && <Footer />}
      {!isAdminPath && <WhatsAppWidget />}
    </LanguageProvider>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
